// src/components/HR/PayrollMonthly.jsx
import React, { useState } from 'react';
import { Pencil, Trash2 } from 'lucide-react';
import { format } from 'date-fns';
import { Dialog, DialogTrigger, DialogContent } from '../../Shared/Dialog';
import Button from '../../Shared/Button';
// import { Card } from '../../Shared/Card';
import Input from '../../Shared/Input';
import { notify } from '../../Shared/toast';
import NavigationLinksHr from './NavLinkHr';

const mockPayroll = [
  {
    id: 1,
    name: 'Rahim Uddin',
    department: 'Operations',
    basic: 25000,
    bonus: 3000,
    deduction: 1000,
    status: 'Paid',
    payslip: 'https://example.com/payslip/1',
  },
  {
    id: 2,
    name: 'Salma Akter',
    department: 'Accounts',
    basic: 22000,
    bonus: 2000,
    deduction: 500,
    status: 'Unpaid',
    payslip: 'https://example.com/payslip/2',
  },
  {
    id: 3,
    name: 'Nasim Mia',
    department: 'Maintenance',
    basic: 18000,
    bonus: 0,
    deduction: 300,
    status: 'Paid',
    payslip: 'https://example.com/payslip/3',
  },
];

function PayrollMonthly() {
  const [filter, setFilter] = useState('All');
  const [search, setSearch] = useState('');
  const [month, setMonth] = useState(format(new Date(), 'yyyy-MM'));
  const [setModalData] = useState(null);

  const filtered = mockPayroll.filter((p) => {
    const nameMatch = p.name.toLowerCase().includes(search.toLowerCase());
    const statusMatch = filter === 'All' || p.status === filter;
    return nameMatch && statusMatch;
  });

  return (
    <div className="p-6 space-y-6">
      <div className="flex flex-wrap justify-center gap-2 md:gap-3 py-2">
        <NavigationLinksHr />
      </div>
      <div className="flex flex-col md:flex-row justify-between items-center gap-4">
        <h2 className="text-2xl font-bold">Payroll - Monthly View</h2>
        <div className="flex items-center gap-4">
          <Input
            type="month"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
            className="max-w-[150px]"
          />
          <Input
            type="text"
            placeholder="Search name..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <select
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className="border rounded px-3 py-1"
          >
            <option>All</option>
            <option>Paid</option>
            <option>Unpaid</option>
          </select>
        </div>
      </div>

      <div className="overflow-x-auto bg-white border rounded-xl shadow">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="text-left px-4 py-2">Name</th>
              <th className="text-left px-4 py-2">Department</th>
              <th className="text-left px-4 py-2">Basic</th>
              <th className="text-left px-4 py-2">Bonus</th>
              <th className="text-left px-4 py-2">Deduction</th>
              <th className="text-left px-4 py-2">Net Pay</th>
              <th className="text-left px-4 py-2">Status</th>
              <th className="text-left px-4 py-2">Action</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((p) => (
              <tr key={p.id} className="border-t hover:bg-gray-50">
                <td className="px-4 py-2 font-medium">{p.name}</td>
                <td className="px-4 py-2">{p.department}</td>
                <td className="px-4 py-2">
                  ৳
                  {p.basic}
                </td>
                <td className="px-4 py-2">
                  ৳
                  {p.bonus}
                </td>
                <td className="px-4 py-2">
                  ৳
                  {p.deduction}
                </td>
                <td className="px-4 py-2 font-semibold">
                  ৳
                  {p.basic + p.bonus - p.deduction}
                </td>
                <td className="px-4 py-2">
                  <span
                    className={`text-xs px-2 py-1 rounded-full font-medium ${
                      p.status === 'Paid'
                        ? 'bg-green-100 text-green-700'
                        : 'bg-yellow-100 text-yellow-700'
                    }`}
                  >
                    {p.status}
                  </span>
                </td>
                <td className="px-4 py-3">
                  <div className="flex space-x-2">
                    {/* View Payslip (Dialog) */}
                    <Dialog>
                      <DialogTrigger asChild>
                        <Button
                          onClick={() => setModalData(p)}
                          size="sm"
                          variant="outline"
                        >
                          View
                        </Button>
                      </DialogTrigger>
                      <DialogContent className="max-w-lg">
                        {/* Payslip content here */}
                      </DialogContent>
                    </Dialog>

                    {/* Edit icon */}
                    <button
                      type="button"
                      className="text-blue-500 hover:text-blue-700"
                      onClick={() => {
                        notify.info('Edit feature coming soon');
                        // open edit modal or inline form
                      }}
                    >
                      <Pencil className="w-4 h-4" />
                    </button>

                    {/* Delete icon */}
                    <button
                      type="button"
                      className="text-red-500 hover:text-red-700"
                      onClick={() => {
                        notify.info('Delete feature not implemented');
                        // confirmation + delete logic
                      }}
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </div>
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default PayrollMonthly;
